let resolvedBackendUrl: string;

if (import.meta.env.DEV) {
    // --- DEVELOPMENT MODE ---
    resolvedBackendUrl = import.meta.env.VITE_BACKEND_URL || 'http://localhost:3000/fallback-dev-url';

} else {

    resolvedBackendUrl = '/api';
}

export const BACKEND_URL = resolvedBackendUrl;
